module.exports = __webpack_public_path__ + "static/img/8bac.9d15e0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/gameNewPic/8bac.jpg
// module id = Ulg1
// module chunks = 1